export default "__VITE_ASSET__0x1SOiXn__"